export default __webpack_public_path__ + "static/media/south-korea.95e12a3e.png";